import { Volume2, VolumeX } from 'lucide-react'
import { useEffect, useState } from 'react'
import { notificationSound } from '@/lib/notification-sound'
import { browserNotifications } from '@/lib/browser-notifications'

export function NotificationSoundToggle() {
  const [muted, setMuted] = useState<boolean>(() => notificationSound.isMuted())

  useEffect(() => {
    if (browserNotifications.permission() === 'default') {
      browserNotifications.requestPermission().catch(() => {})
    }
  }, [])

  function toggle() {
    const next = !muted
    notificationSound.setMuted(next)
    setMuted(next)
    if (!next) notificationSound.play()
  }

  return (
    <button
      onClick={toggle}
      className="p-2 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg"
      title={muted ? 'Zapnúť zvuk notifikácií' : 'Stlmiť zvuk notifikácií'}
      aria-label={muted ? 'Zapnúť zvuk notifikácií' : 'Stlmiť zvuk notifikácií'}
    >
      {muted ? <VolumeX size={18} /> : <Volume2 size={18} />}
    </button>
  )
}
